<template>
  <v-container fluid class="pa-2 dp-container">
    <!-- Header -->
    <div class="dashboard-header">
      <div class="header-content">
        <div class="d-flex align-center">
          <div class="icon-wrapper">
            <v-icon color="#023449" size="28">mdi-folder-download-outline</v-icon>
          </div>
          <div class="ml-3">
            <h1 class="dashboard-title">Departamento Pessoal</h1>
            <p class="dashboard-subtitle">Apuração, conferência e exportação de valores para fechamento da folha Senior</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo -->
    <div class="dashboard-content">
      <router-view />
    </div>
  </v-container>
</template>

<script>

export default {
  name: "DepartamentoPessoalContainer",
};
</script>

<style scoped>
.dp-container {
  min-height: calc(100vh - 300px);
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0 8px 8px 8px;
}

.dashboard-header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.header-content {
  flex: 1;
}

.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #023449;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.dashboard-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
}

/* Conteúdo */
.dashboard-content {
  padding: 0;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .dashboard-header { padding: 20px; }
  .dashboard-title  { font-size: 1.25rem; }
  .dashboard-subtitle { font-size: 0.813rem; }
}

@media (max-width: 480px) {
  .dashboard-title  { font-size: 1.125rem; }
  .icon-wrapper     { padding: 10px; }
}

@media (prefers-reduced-motion: reduce) {
  .dashboard-content { animation: none !important; }
}
</style>